export default class KpiDefinition
{
    constructor(name, aggregation, title, formatter = null, unit = null) {
        this.name = name;
        this.aggregation = aggregation;
        this.title = title;
        this.formatter = formatter;
        this.unit = unit;
    }

    defaultFormatter(value) {
        return value + (this.unit ? this.unit : '');
    };

    build(value) {
        return {
            name: this.name,
            title: this.title,
            value: typeof this.unit == 'function' ? this.unit : this.unit,
            formatted: typeof this.formatter == 'function' ? this.formatter(value) : this.defaultFormatter(value),
        };
    }
}